// Sidebar.js
import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../logo-2.png";
import vector1 from "../Vector(4).png";
import vector2 from "../Vector(1).png";
import vector3 from "../Vector(2).png";
import vector4 from "../Vector(3).png";

const Sidebar = () => {
  const [openVis1, setOpenVis1] = useState(false);
  const [openVis2, setOpenVis2] = useState(false);
  const [openVis3, setOpenVis3] = useState(false);
  const [openVis4, setOpenVis4] = useState(false);
  const [openVis5, setOpenVis5] = useState(false);

  return (
    <nav
      className="col-md-2 min-vh-100 sidebar"
      style={{
        background: "white",
        borderRight: ".4px solid #D4D4D4",
      }}
    >
      <div className="position-sticky pt-3">
        <div className="d-flex justify-content-between align-items-center pt-2 pb-5">
          <img src={logo} style={{ width: "55%" }} alt="Logo" />
        </div>
        <ul className="flex-column justify-content-around gap-2 nav">
          {/* Visualization 1 */}
          <li className="nav-item">
            <button
              className="btn btn-toggle text-start w-100"
              onClick={() => setOpenVis1(!openVis1)}
              style={{
                display: "flex",
                justifyContent: "left",
                alignItems: "center",
                gap: "10px",
                fontWeight: "600",
                color: "#75738C",
              }}
            >
              <img
                src={vector1}
                className="h-5 w-5"
                style={{
                  width: "20px",
                  height: "20px",
                  color: "blue !important",
                }}
                alt="Visualization 1"
              />
              Visualization 1 <i className="fa fa-caret-down"></i>
            </button>
            {openVis1 && (
              <ul className="flex-column nav ps-3">
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/stacked-bar-color"
                    style={{ color: "#12273b" }}
                  >
                    Stacked Bar Chart | V 1.1
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/stacked-bar"
                    style={{ color: "#12273b" }}
                  >
                    Stacked Bar Chart | V 1.2
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/3Dpercentage"
                    style={{ color: "#12273b" }}
                  >
                    3D Percentage Chart | V 2.1
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/2Dpercentage"
                    style={{ color: "#12273b" }}
                  >
                    2D Percentage Chart | V 2.2
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/3Dpercentage-color"
                    style={{ color: "#12273b" }}
                  >
                    3D Percentage Color 2 | V 2.3
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/2Dpercentage-color"
                    style={{ color: "#12273b" }}
                  >
                    2D Percentage Color 2 | V 2.4
                  </Link>
                </li>
              </ul>
            )}
          </li>

          {/* Visualization 2 */}
          <li className="nav-item">
            <button
              className="btn btn-toggle text-start w-100"
              style={{
                display: "flex",
                justifyContent: "left",
                alignItems: "center",
                gap: "10px",
                fontWeight: "600",
                color: "#75738C",
              }}
              onClick={() => setOpenVis2(!openVis2)}
            >
              <img
                src={vector2}
                className="h-5 w-5"
                style={{
                  width: "20px",
                  height: "20px",
                  color: "blue !important",
                }}
                alt="Visualization 2"
              />
              Visualization 2 <i className="fa fa-caret-down"></i>
            </button>
            {openVis2 && (
              <ul className="flex-column nav ps-3">
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/Diverging-Bar3"
                    style={{ color: "#12273b" }}
                  >
                    Diverging Bar V2.2
                  </Link>
                </li>
              </ul>
            )}
          </li>

          {/* Visualization 3 */}
          <li className="nav-item">
            <button
              className="btn btn-toggle text-start w-100"
              style={{
                display: "flex",
                justifyContent: "left",
                alignItems: "center",
                gap: "10px",
                fontWeight: "600",
                color: "#75738C",
              }}
              onClick={() => setOpenVis3(!openVis3)}
            >
              <img
                src={vector3}
                className="h-5 w-5"
                style={{
                  width: "20px",
                  height: "20px",
                  color: "blue !important",
                }}
                alt="Visualization 3"
              />
              Visualization 3 <i className="fa fa-caret-down"></i>
            </button>
            {openVis3 && (
              <ul className="flex-column nav ps-3">
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/Drilldown1"
                    style={{ color: "#12273b" }}
                  >
                    V1
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/Drilldown2.1"
                    style={{ color: "#12273b" }}
                  >
                    Drilldown V2.1
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/Drilldown2.1newColor"
                    style={{ color: "#12273b" }}
                  >
                    Drilldown V2.1 (MPM's Color)
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/Drilldown2.2"
                    style={{ color: "#12273b" }}
                  >
                    Drilldown V2.2
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/Drilldown4"
                    style={{ color: "#12273b" }}
                  >
                    V4
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/Drilldown5.1"
                    style={{ color: "#12273b" }}
                  >
                    Drilldown V5.1
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/Drilldown5.2"
                    style={{ color: "#12273b" }}
                  >
                    Drilldown V5.2
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/Drilldown5.3"
                    style={{ color: "#12273b" }}
                  >
                    Drilldown V5.3
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/Drilldown5.4"
                    style={{ color: "#12273b" }}
                  >
                    Drilldown V5.4
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/Drilldown5.5"
                    style={{ color: "#12273b" }}
                  >
                    Drilldown V5.5
                  </Link>
                </li>
              </ul>
            )}
          </li>

          {/* Visualization 4 */}
          <li className="nav-item">
            <button
              className="btn btn-toggle text-start w-100"
              style={{
                display: "flex",
                justifyContent: "left",
                alignItems: "center",
                gap: "10px",
                fontWeight: "600",
                color: "#75738C",
              }}
              onClick={() => setOpenVis4(!openVis4)}
            >
              <img
                src={vector4}
                className="h-5 w-5"
                style={{ width: "20px", height: "20px" }}
                alt="Visualization 4"
              />
              Visualization 4 <i className="fa fa-caret-down"></i>
            </button>
            {openVis4 && (
              <ul className="flex-column nav ps-3">
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/Widgets1"
                    style={{ color: "#12273b" }}
                  >
                    V1
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/Widgets2"
                    style={{ color: "#12273b" }}
                  >
                    V2
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/Widgets3"
                    style={{ color: "#12273b" }}
                  >
                    V3
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/Widgets4"
                    style={{ color: "#12273b" }}
                  >
                    V4
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/Widgets5"
                    style={{ color: "#12273b" }}
                  >
                    V5
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/Widgets6"
                    style={{ color: "#12273b" }}
                  >
                    V6
                  </Link>
                </li>
                <hr className="m-1" />
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/Widgets7"
                    style={{ color: "#12273b" }}
                  >
                    V7
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/Widgets8.1"
                    style={{ color: "#12273b" }}
                  >
                    V8.1
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/Widgets8.2"
                    style={{ color: "#12273b" }}
                  >
                    V8.2
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/Widgets8.3"
                    style={{ color: "#12273b" }}
                  >
                    V8.3
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/Widgets9"
                    style={{ color: "#12273b" }}
                  >
                    V9
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/Widgets10"
                    style={{ color: "#12273b" }}
                  >
                    V10
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/Widgets11"
                    style={{ color: "#12273b" }}
                  >
                    V11
                  </Link>
                </li>
              </ul>
            )}
          </li>

          {/* Visualization 5 - Scatter and Box Plot */}
          <li className="nav-item">
            <button
              className="btn btn-toggle text-start w-100"
              style={{
                display: "flex",
                justifyContent: "left",
                alignItems: "center",
                gap: "10px",
                fontWeight: "600",
                color: "#75738C",
              }}
              onClick={() => setOpenVis5(!openVis5)}
            >
              <i className="fa fa-th" aria-hidden="true"></i>
              Scatter and Box Plot <i className="fa fa-caret-down"></i>
            </button>
            {openVis5 && (
              <ul className="flex-column nav ps-3">
                {/* Existing scatter plot routes */}

                {/* Boxplot route */}
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/Boxplot"
                    style={{ color: "#12273b" }}
                  >
                    Boxplot
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/Boxplot2"
                    style={{ color: "#12273b" }}
                  >
                    Boxplot 2
                  </Link>
                </li>
                <hr class="m-1"></hr>
                {/* New data Scatter Jitter Plot */}
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/Scatterplot"
                    style={{ color: "#12273b" }}
                  >
                    Scatter Jitter Plot
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/Scatterplot2"
                    style={{ color: "#12273b" }}
                  >
                    Scatter Jitter Plot 2
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/Scatterplot3"
                    style={{ color: "#12273b" }}
                  >
                    Scatter Jitter Plot 2.1
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/Scatterplot4"
                    style={{ color: "#12273b" }}
                  >
                    Scatter Jitter Plot 3
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/Scatterplot5"
                    style={{ color: "#12273b" }}
                  >
                    Scatter Jitter Plot 3.1
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/Scatterplot6"
                    style={{ color: "#12273b" }}
                  >
                    Scatter Jitter Plot 3.2
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/Histogram"
                    style={{ color: "#12273b" }}
                  >
                   Histogram 1
                  </Link>
                  <Link
                    className="nav-link"
                    to="/Histogram2"
                    style={{ color: "#12273b" }}
                  >
                   Histogram 2
                  </Link>
                </li>
               
              </ul>
            )}
          </li>
          <li className="nav-item">
            <Link
              className="btn btn-toggle text-start w-100"
              to="/UpsetPlot1"
              style={{
                display: "flex",
                justifyContent: "left",
                alignItems: "center",
                gap: "10px",
                fontWeight: "600",
                color: "#75738C",
                textDecoration: "none",
              }}
            >
              <i className="fa fa-share-alt" aria-hidden="true"></i>
              Upset Plot
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Sidebar;
